export default {
  /*
  update: function (el, binding, vnode) {
  },
  */
  inserted: function (el, binding, vnode) {
    el.focus()
  }
}



// WEBPACK FOOTER //
// ./src/directives/Autofocus.js